<ng-template #openModal >
    
                <ng-content></ng-content>
</ng-template>